@let format = fmt();

<div class="datetime-field">
  @if (label().length > 0) {
    <label class="label">{{ label() }}</label>
  }

  <div
    #trigger
    class="trigger"
    [class.is-open]="open()"
    [class.is-disabled]="disabled()"
    [class.is-empty]="value() === null"
    (click)="toggle()">
    <fa-duotone-icon class="lead-icon" [icon]="faCalendarClock"></fa-duotone-icon>
    <span class="value">{{ displayText() }}</span>
    @if (clearable() && value() !== null && !disabled()) {
      <button
        type="button"
        class="clear"
        [attr.aria-label]="'Clear' | translate"
        (click)="clear($event)">
        <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
      </button>
    }
  </div>

  <andor-context-menu
    mode="styled"
    yPosition="below"
    [overlapTrigger]="false"
    (opened)="onOpened()"
    (closed)="onClosed()">
    <div class="picker">
      <!-- Calendar -->
      <div class="calendar">
        <div class="cal-header">
          <button
            type="button"
            class="nav"
            [disabled]="!canGoPrev()"
            [attr.aria-label]="'Previous month' | translate"
            (click)="prevMonth()">
            <fa-duotone-icon [icon]="faChevronLeft"></fa-duotone-icon>
          </button>
          <span class="month-label">{{ monthLabel() }}</span>
          <button
            type="button"
            class="nav"
            [disabled]="!canGoNext()"
            [attr.aria-label]="'Next month' | translate"
            (click)="nextMonth()">
            <fa-duotone-icon [icon]="faChevronRight"></fa-duotone-icon>
          </button>
        </div>

        <div class="weekdays">
          @for (wd of format.weekdayLabels; track $index) {
            <span class="weekday">{{ wd }}</span>
          }
        </div>

        <div class="days">
          @for (cell of grid(); track cell.year + '-' + cell.month + '-' + cell.day) {
            @let dayDisabled = isDayDisabledCell(cell);
            <button
              type="button"
              class="day"
              [class.is-outside]="!cell.inCurrentMonth"
              [class.is-today]="isToday(cell)"
              [class.is-selected]="isSelectedDay(cell)"
              [class.is-disabled]="dayDisabled"
              [disabled]="dayDisabled"
              (click)="selectDay(cell)">
              {{ cell.day }}
            </button>
          }
        </div>
      </div>

      <!-- Time wheels + footer actions (right column on the side-by-side layout) -->
      <div class="right">
        <div class="time">
          <!-- Shared selection lens: sibling of the wheels (a masked scroll
               container would fade it out), painted behind the slot text. -->
          <div class="lens" aria-hidden="true"></div>

          <div class="col" #hourList>
            @for (h of hourValues(); track h) {
              @let hourDisabled = isHourDisabledFor(h);
              <button
                type="button"
                class="slot"
                [class.is-selected]="isSelectedHour(h)"
                [class.is-disabled]="hourDisabled"
                [disabled]="hourDisabled"
                (click)="setHour(h)">
                {{ hourLabel(h) }}
              </button>
            }
          </div>

          <div class="col" #minuteList>
            @for (m of minuteSteps; track m) {
              @let minuteDisabled = isMinuteDisabledFor(m);
              <button
                type="button"
                class="slot"
                [class.is-selected]="isSelectedMinute(m)"
                [class.is-disabled]="minuteDisabled"
                [disabled]="minuteDisabled"
                (click)="setMinute(m)">
                {{ minuteLabel(m) }}
              </button>
            }
          </div>

          @if (format.hour12) {
            <div class="col" #periodList>
              @let amDisabled = isPeriodDisabled(false);
              <button
                type="button"
                class="slot"
                [class.is-selected]="!isPm()"
                [class.is-disabled]="amDisabled"
                [disabled]="amDisabled"
                (click)="setPeriod(false)">
                {{ format.dayPeriods.am }}
              </button>
              @let pmDisabled = isPeriodDisabled(true);
              <button
                type="button"
                class="slot"
                [class.is-selected]="isPm()"
                [class.is-disabled]="pmDisabled"
                [disabled]="pmDisabled"
                (click)="setPeriod(true)">
                {{ format.dayPeriods.pm }}
              </button>
            </div>
          }
        </div>

        <div class="actions">
          <button type="button" class="action-btn action-btn--cancel" (click)="cancel()">
            {{ 'Cancel' | translate }}
          </button>
          <button type="button" class="action-btn action-btn--confirm" (click)="confirm()">
            {{ 'Confirm' | translate }}
          </button>
        </div>
      </div>
    </div>
  </andor-context-menu>
</div>
